/* eslint-disable jsx-a11y/heading-has-content */

/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { cleanExternalLinks } from '../../lib/utils';

import styles from '../../../styles/blocks/title.module.scss';

const propTypes = {
    tag: PropTypes.oneOf(['h3', 'h4', 'h5', 'h6']),
    body: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    tag: null,
    body: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const TitleBlock = ({ tag, body, className, isContainer, containerClassName }) => {
    const Tag = tag !== null ? tag : 'h3';
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    'blockTitle',
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {body !== null ? (
                    <Tag
                        className={styles.title}
                        dangerouslySetInnerHTML={{ __html: cleanExternalLinks(body) }}
                    />
                ) : null}
            </div>
        </div>
    );
};

TitleBlock.propTypes = propTypes;
TitleBlock.defaultProps = defaultProps;

export default TitleBlock;
